import * as Yup from 'yup'

export const accountSubscriptionPricesSchema = Yup.object().shape({
  plus_1m: Yup.object().nullable().required('validation-required'),
  plus_12m: Yup.object().nullable().required('validation-required'),
  premium_1m: Yup.object().nullable().required('validation-required'),
  premium_12m: Yup.object().nullable().required('validation-required'),
})
